import React from 'react';
import {connect} from 'react-redux';

import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';

import audioNo from 'assets/sounds/no/5 1 Leseforstaelse Intro.mp3';
import audioNn from 'assets/sounds/nn/5 1 Leseforstaelse Intro.m4a';

import tutorialVideo from './assets/99c06a75c2d10f2ad5d81a1aa870fc65.mp4';

class Intro extends React.Component {
	constructor(props) {
		super(props);

		const audioObj = {
			no: audioNo,
			nn: audioNn,
		};
		this.leseprovenIntro = this.props.isDldTest ? strings.leseprovenIntroNorming:strings.leseprovenIntro;
		this.leseprovenTimeLimit = this.props.isDldTest
			? strings.leseprovenTimeLimitNorming
			: strings.leseprovenTimeLimit;

		this.audio = audioObj[strings.getLanguage()];
	}

	render() {
		const {onNextStep} = this.props;

		let videoRef;

		return (
			<div>
				<div className={this.props.isDldTest? "text-center":"text-left"}>
					<p>
						<AudioPlayer
							autoplay
							onErrorPlay={()=>{
								console.log('Something went wrong');
							}}
							inline
							onPause={() => {
								videoRef.play();
							}}
							src={this.audio}
						/>
						{this.leseprovenIntro}
					</p>
					<p>{this.leseprovenTimeLimit}</p>
				</div>
				<div className="lit-test-content">
				<div className="lit-preview">
					<p className="lit-preview__label">
						{strings.testLooksLikeThis}
					</p>
					<video
						className="lit-preview__video"
						loop
						ref={(ref) => {
							videoRef = ref;
						}}
						src={tutorialVideo}
					/>
				</div>
				</div>
				<div className="lit-test-button-wrapper">
				<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.start}
				</button>
				</div>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
